import { render, staticRenderFns } from "./InvalidToken.vue?vue&type=template&id=1f4790d4&scoped=true&lang=pug"
import script from "./InvalidToken.vue?vue&type=script&lang=js"
export * from "./InvalidToken.vue?vue&type=script&lang=js"
import style0 from "./InvalidToken.vue?vue&type=style&index=0&id=1f4790d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f4790d4",
  null
  
)

export default component.exports